module.exports = __webpack_public_path__ + "3f437b7ad209d9503302c8b9169f5489.png";